<div class="auth-container">

  <div class="auth-card">

    <h2 class="auth-title">Ingresá</h2>

    <div class="alert alert-danger" *ngIf="!!errorMessage">
      {{ errorMessage }}
    </div>

    <form (ngSubmit)="onSubmit(f.form)" #f="ngForm" novalidate>

      <div class="form-group">
        <label>Email</label>
        <input
          type="email"
          class="form-control"
          name="email"
          [(ngModel)]="user.email"
          #email="ngModel"
          [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
          required email
        >
      </div>

      <div class="form-group">
        <label>Contraseña</label>
        <input
          type="password"
          class="form-control"
          name="password"
          [(ngModel)]="user.password"
          #password="ngModel"
          [ngClass]="{ 'is-invalid': f.submitted && password.invalid }"
          required minlength="6"
        >

        <a class="forgot-link" routerLink="/auth/forgot-password">
          Olvidé mi contraseña
        </a>
      </div>

      <button
        type="submit"
        class="btn btn-success btn-block btn-lg mt-3"
        [disabled]="f.invalid"
      >
        Ingresar
      </button>

    </form>

  </div>

</div>